import { useEffect, useRef, useState } from "react";
import { GLOSSARY } from "../glossary";

/**
 * The shared field-helper (?) affordance. Hover shows the definition via
 * native title (works everywhere, zero JS); click pins it open (for touch,
 * or a reader who wants to keep reading it) until they click elsewhere.
 * Every instance pulls from the ONE canonical glossary -- never a
 * per-page ad-hoc explanation, so a term reads the same everywhere.
 */
export function FieldHelp({ term }: { term: string }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);
  const entry = GLOSSARY[term];

  useEffect(() => {
    if (!open) return;
    function onDocClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  if (!entry) return null;

  return (
    <span ref={ref} className="field-help" style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        className="field-help-btn"
        title={entry.text}
        aria-label={`What is ${entry.label}?`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
      >
        ?
      </button>
      {open && (
        <span className="field-help-pop" onClick={(e) => e.stopPropagation()}>
          <span className="field-help-pop-title">{entry.label}</span>
          <span className="field-help-pop-text">{entry.text}</span>
        </span>
      )}
    </span>
  );
}
